import { emptySplitApi } from '../../../store/emptyApi';

export interface TeamSnapshotLeader {
  leader_id: number;
  leader_first_name: string | null;
  leader_last_name: string | null;
  leader_email: string | null;
  score: number;
  score_components?: Record<string, number>;
  weekly_points_history?: Array<{ week_start: string; points: number }>;
}

export const leaderboardApi = emptySplitApi.injectEndpoints({
  endpoints: build => ({
    getTeamSnapshotLeaders: build.query<TeamSnapshotLeader[], { assessmentPeriodId: number | null }>({
      query: ({ assessmentPeriodId }) => ({
        url: '/api/portal/v1/team-snapshots/leaders/',
        params: {
          assessment_period_id: assessmentPeriodId,
        },
      }),
      transformResponse: (response: any) => response?.results || [],
    }),
  }),
  overrideExisting: false,
});

export const { useGetTeamSnapshotLeadersQuery } = leaderboardApi;
